"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _Form = require("@quixeltools/quixel-ui-library/dist/components/common/website/Form");

var _Form2 = _interopRequireDefault(_Form);

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Hr = require("@quixeltools/quixel-ui-library/dist/components/common/website/Hr");

var _Hr2 = _interopRequireDefault(_Hr);

var _TextButton = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/TextButton");

var _TextButton2 = _interopRequireDefault(_TextButton);

var _Columns = require("@quixeltools/quixel-ui-library/dist/components/common/website/Columns");

var _Columns2 = _interopRequireDefault(_Columns);

var _SubmitArtPopup = require("@quixeltools/quixel-ui-library/dist/components/common/gallery/SubmitArtPopup");

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _humanize = require("@quixeltools/quixel-ui-library/dist/utils/humanize");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(1.5),
  marginBottom: (0, _css.unitRem)(1.5)
});

var columnTitle = (0, _glamor.css)({
  display: "block",

  fontSize: (0, _css.unitRem)(0.625),
  fontWeight: 600,
  color: _css.colors.gray,
  textTransform: "uppercase",

  marginBottom: (0, _css.unitRem)(1)
});

var detailsOld = (0, _glamor.css)({
  color: _css.colors.gray,
  lineHeight: 1.4
});

var details = (0, _glamor.css)({
  color: _css.colors.white,
  lineHeight: 1.4
});

var line = (0, _glamor.css)({
  display: "block",
  position: "relative"
});

var city = (0, _glamor.css)({
  marginLeft: (0, _css.unitRem)(0.25)
});

var linePush = (0, _glamor.css)({
  display: "block",
  marginBottom: (0, _css.unitRem)(1)
});

var checkBox = function checkBox(hide) {
  return (0, _glamor.css)({
    display: hide ? "none" : "block",
    color: _css.colors.gray + " !important",
    marginTop: (0, _css.unitRem)(1),
    "& label": {
      "& span": {
        color: _css.colors.gray + " !important",
        lineHeight: "1.25em",
        "& span": {
          minWidth: "1.125em",
          "& span": {
            minWidth: "unset"
          }
        }
      }
    }
  });
};

var subscriptions = function subscriptions(hide) {
  return (0, _glamor.css)({
    display: hide ? "none" : "block",
    marginTop: (0, _css.unitRem)(1),
    marginBottom: (0, _css.unitRem)(1)
  });
};

var summary = function summary(show) {
  return (0, _glamor.css)({
    display: show ? "block" : "none",
    marginTop: (0, _css.unitRem)(1),
    marginBottom: (0, _css.unitRem)(1)
  });
};

var priceLine = (0, _glamor.css)(_css.clearfix, {
  "& .label": {
    color: _css.colors.white,
    float: "left"
  },

  "& .value": {
    color: _css.colors.white,
    float: "right"
  }
});

var redPriceLine = (0, _glamor.css)(_css.clearfix, {
  "& .label": {
    color: _css.colors.blue,
    float: "left"
  },

  "& .value": {
    color: _css.colors.blue,
    float: "right"
  }
});

var strikedThroughContainer = (0, _glamor.css)({
  position: "relative",
  marginRight: (0, _css.unitRem)(0.15)
});

var strikedThrough = (0, _glamor.css)({
  color: _css.colors.blue,
  ":after": {
    content: "''",
    position: "absolute",
    borderBottom: "1px solid " + _css.colors.blue,
    top: "50%",
    left: 0,
    right: 0
  }
});

var summaryHeading = (0, _glamor.css)({
  color: _css.colors.white,
  fontSize: "1.125em"
});

var note = (0, _glamor.css)({
  display: "block",
  color: _css.colors.white,
  marginBottom: (0, _css.unitRem)(1)
});

var foot = (0, _glamor.css)({
  display: "block",

  marginTop: (0, _css.unitRem)(1)
});

var submitButton = (0, _glamor.css)({
  marginTop: (0, _css.unitRem)(1),
  textAlign: "right",
  display: "block"
});

var tos = (0, _glamor.css)({
  color: _css.colors.gray,
  fontSize: "1em"
});

var tosLink = (0, _glamor.css)({
  fontSize: "1em"
});

var paragraph = (0, _glamor.css)({
  lineHeight: 1.4,
  marginTop: 0,
  marginBottom: (0, _css.unitRem)(1),
  color: _css.colors.gray
});

var email = (0, _glamor.css)({
  color: _css.colors.white,
  marginLeft: (0, _css.unitRem)(0.25)
});

var YourPurchase = function YourPurchase(props) {
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "span",
      { className: columnTitle },
      "Your Purchase"
    ),
    _react2.default.createElement(
      "div",
      { className: details },
      _react2.default.createElement(
        "div",
        { className: priceLine },
        _react2.default.createElement(
          "span",
          { className: "label" },
          props.newSubscription.name,
          props.newSubscription.numberOfSeats > 0 && " x " + props.newSubscription.numberOfSeats
        ),
        _react2.default.createElement(
          "span",
          { className: "value" },
          (0, _humanize.price)(props.newSubscription.price)
        )
      ),
      _react2.default.createElement(
        "div",
        { className: priceLine },
        _react2.default.createElement(
          "span",
          { className: "label" },
          "Subtotal"
        ),
        _react2.default.createElement(
          "span",
          { className: "value" },
          (0, _humanize.price)(props.newSubscription.subTotal)
        )
      ),
      _react2.default.createElement(
        "div",
        { className: priceLine },
        _react2.default.createElement(
          "span",
          { className: "label" },
          "Taxes"
        ),
        _react2.default.createElement(
          "span",
          { className: "value" },
          (0, _humanize.price)(props.newSubscription.taxes)
        )
      ),
      _react2.default.createElement(
        "div",
        { className: priceLine },
        _react2.default.createElement(
          "span",
          { className: "label" },
          "Total"
        ),
        _react2.default.createElement(
          "span",
          { className: "value" },
          (0, _humanize.price)(props.newSubscription.total)
        )
      )
    )
  );
};

var UpgradeSubscriptionPopupForum = function UpgradeSubscriptionPopupForum(props) {
  return _react2.default.createElement(
    _Form2.default,
    {
      className: _SubmitArtPopup.popup,
      error: props.error,
      onSubmit: props.onSubmit,
      onChildRef: props.onChildRef
    },
    _react2.default.createElement(
      "div",
      { className: _SubmitArtPopup.header },
      _react2.default.createElement("img", { src: props.icon, alt: "", className: _SubmitArtPopup.icon }),
      _react2.default.createElement(
        "div",
        { className: _SubmitArtPopup.heading },
        _react2.default.createElement(
          "h1",
          { className: _SubmitArtPopup.h1 },
          props.showSummary ? "Thank You!" : "Switch to Annual"
        ),
        _react2.default.createElement(
          "p",
          { className: _SubmitArtPopup.p },
          props.showSummary ? "Thank you for purchasing " + props.currentSubscription.name + " Annual subscription." : "Please verify the information below."
        )
      )
    ),
    _react2.default.createElement(
      "section",
      { className: subscriptions(props.showSummary) },
      _react2.default.createElement(
        _Columns2.default,
        { className: columns, n: 2 },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { className: columnTitle },
            "Current Subscription"
          ),
          _react2.default.createElement(
            "div",
            { className: detailsOld },
            _react2.default.createElement(
              "span",
              { className: line },
              props.currentSubscription.name,
              props.currentSubscription.numberOfSeats > 0 && " x " + props.currentSubscription.numberOfSeats
            ),
            props.currentSubscription.price && _react2.default.createElement(
              "span",
              { className: line },
              "$" + props.currentSubscription.price + (props.currentSubscription.isMultiSeat ? " / seat" : "") + " / month"
            ),
            _react2.default.createElement(
              "span",
              {
                className: line
              },
              props.currentSubscription.points + " points / month"
            ),
            _react2.default.createElement(
              "span",
              { className: line },
              "Billed Monthly"
            )
          )
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { className: columnTitle },
            "Billing Details"
          ),
          _react2.default.createElement(
            "div",
            { className: detailsOld },
            _react2.default.createElement(
              "span",
              { className: line },
              props.billingDetails.name
            ),
            props.billingDetails.address && _react2.default.createElement(
              "span",
              { className: line },
              props.billingDetails.address
            ),
            _react2.default.createElement(
              "span",
              { className: line },
              _react2.default.createElement(
                "span",
                null,
                props.billingDetails.postalCode
              ),
              props.billingDetails.city && _react2.default.createElement(
                "span",
                { className: city },
                props.billingDetails.city
              )
            ),
            _react2.default.createElement(
              "span",
              { className: linePush },
              props.billingDetails.country
            )
          )
        )
      ),
      _react2.default.createElement(_Hr2.default, null),
      _react2.default.createElement(
        _Columns2.default,
        { className: columns, n: 2 },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { className: columnTitle },
            "New Subscription"
          ),
          _react2.default.createElement(
            "div",
            { className: details },
            _react2.default.createElement(
              "span",
              { className: line },
              props.newSubscription.name,
              props.newSubscription.numberOfSeats > 0 && " x " + props.newSubscription.numberOfSeats
            ),
            _react2.default.createElement(
              "span",
              { className: line },
              "$" + props.newSubscription.subTotal + " / year"
            ),
            _react2.default.createElement(
              "span",
              {
                className: line
              },
              props.newSubscription.points + " points Upfront / year"
            ),
            _react2.default.createElement(
              "span",
              { className: line },
              "Billed Annually"
            )
          )
        ),
        YourPurchase(props)
      ),
      _react2.default.createElement(_Hr2.default, null)
    ),
    _react2.default.createElement(
      "section",
      { className: summary(props.showSummary) },
      _react2.default.createElement(
        "span",
        { className: summaryHeading },
        "Here is a summary:"
      ),
      _react2.default.createElement(
        _Columns2.default,
        { className: columns, n: 2 },
        YourPurchase(props),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { className: columnTitle },
            "Billing Details"
          ),
          _react2.default.createElement(
            "div",
            { className: details },
            _react2.default.createElement(
              "span",
              { className: line },
              props.billingDetails.name
            ),
            props.billingDetails.address && _react2.default.createElement(
              "span",
              { className: line },
              props.billingDetails.address
            ),
            _react2.default.createElement(
              "span",
              { className: line },
              _react2.default.createElement(
                "span",
                null,
                props.billingDetails.postalCode
              ),
              props.billingDetails.city && _react2.default.createElement(
                "span",
                { className: city },
                props.billingDetails.city
              )
            ),
            _react2.default.createElement(
              "span",
              { className: linePush },
              props.billingDetails.country
            ),
            _react2.default.createElement(
              "span",
              null,
              props.paymentLine
            )
          )
        )
      ),
      _react2.default.createElement(_Hr2.default, { className: (0, _glamor.css)((0, _extends3.default)({}, props.showSummary && { display: "none" })) }),
      _react2.default.createElement(
        _Columns2.default,
        { className: columns, n: 2 },
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "span",
            { className: columnTitle },
            "Subscription"
          ),
          _react2.default.createElement(
            "div",
            { className: details },
            _react2.default.createElement(
              "span",
              { className: line },
              "Activation date:"
            ),
            _react2.default.createElement(
              "span",
              { className: linePush },
              props.subscriptionCreatedAt
            ),
            _react2.default.createElement(
              "span",
              { className: line },
              "Next charge:"
            ),
            _react2.default.createElement(
              "span",
              { className: line },
              props.subscriptionNextChargeAt
            )
          )
        ),
        _react2.default.createElement("div", null)
      ),
      _react2.default.createElement(
        "p",
        { className: paragraph },
        "An invoice for this purchase has been emailed to you at:",
        " ",
        _react2.default.createElement(
          "span",
          { className: email },
          props.email
        )
      ),
      _react2.default.createElement(
        "p",
        { className: paragraph },
        "Now, go be creative!"
      ),
      _react2.default.createElement(
        "p",
        { className: paragraph },
        "/ Team Megascans"
      ),
      _react2.default.createElement(_Hr2.default, { className: (0, _glamor.css)((0, _extends3.default)({}, props.showSummary && { display: "none" })) })
    ),
    _react2.default.createElement(
      "div",
      { className: foot },
      props.renderCaptcha(props.fields.captcha),
      _react2.default.createElement(
        _Checkbox2.default,
        (0, _extends3.default)({
          className: checkBox(props.showSummary),
          disabled: props.submitting,
          simpleError: true
        }, props.fields.acceptTos),
        _react2.default.createElement(
          "span",
          { className: tos },
          "By completing this purchase you accept our",
          _react2.default.createElement(_TextButton2.default, {
            className: tosLink,
            mode: "small-gray-underlined",
            href: "/terms",
            label: "Terms of Service",
            newWindow: true
          }),
          ". Annual subscriptions come with the first 3 months off for the first year only. Promo code discounts do not apply to annual subscriptions."
        )
      ),
      props.showSummary ? _react2.default.createElement(_Button2.default, {
        className: submitButton,
        mode: "secondary",
        to: "/library/latest",
        onClick: props.onStartBrowsingClick,
        label: "Start Browsing"
      }) : _react2.default.createElement(_Button2.default, {
        type: "submit",
        className: submitButton,
        mode: "secondary",
        loading: props.submitting,
        label: "Proceed To Payment"
      })
    )
  );
};

exports.default = UpgradeSubscriptionPopupForum;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UpgradeSubscriptionPopup/UpgradeSubscriptionPopupForm.jsx
// module id = 2833
// module chunks = 0